export default __webpack_public_path__ + "static/media/community_cg_01.a5966e32.jpg";